/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-return': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<g _fill="#376F99" fill-rule="evenodd"><path pid="0" d="M9.5 0h-9a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM9 1v8H1V1h8z"/><path pid="1" d="M10 2v1H0V2zM7.486 6.986a.5.5 0 0 1 .092.991l-.09.009L2.502 8a.5.5 0 0 1-.092-.992L2.499 7l4.987-.014zM3.532 4.528l3.956.01a.5.5 0 0 1 .088.993l-.09.008-3.956-.01a.5.5 0 0 1-.087-.993l.09-.008z"/><path pid="2" d="M7.487 4.539a.5.5 0 0 1 .492.41l.008.09v2.447a.5.5 0 0 1-.992.09l-.008-.09V5.039a.5.5 0 0 1 .5-.5zM3.157 3.636a.5.5 0 0 1 .746.66l-.06.068-.636.598.656.694a.5.5 0 0 1 .04.64l-.06.067a.5.5 0 0 1-.639.04l-.067-.06-1-1.057a.5.5 0 0 1-.04-.64l.06-.067 1-.943z"/></g>'
  }
})
